import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { i18n } from "../../../translate/i18n";
import InfoTip from "./InfoTip";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  title: { marginBottom: theme.spacing(1.5), fontWeight: 600 },
  subTitle: {
    fontWeight: 600,
    fontSize: 13,
    color: "#555",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
  },
}));

const BTable = ({ rows, keyLabel }) => {
  if (!rows || rows.length === 0) return null;
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{keyLabel}</TableCell>
          <TableCell align="right">{i18n.t("aiAssistantStats.funnel.enviados")}</TableCell>
          <TableCell align="right">{i18n.t("aiAssistantStats.funnel.respondieron")}</TableCell>
          <TableCell align="right">{i18n.t("aiAssistantStats.kpis.satisfechos")}</TableCell>
          <TableCell align="right">{i18n.t("aiAssistantStats.kpis.reclamos")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r, i) => {
          const k = r.sucursal ?? r.tipoEncuesta ?? r.subtipo ?? "—";
          return (
            <TableRow key={i}>
              <TableCell>{k === "sin_dato" ? "—" : (k || "—")}</TableCell>
              <TableCell align="right">{r.enviados ?? 0}</TableCell>
              <TableCell align="right">{r.respondieron ?? 0}</TableCell>
              <TableCell align="right">{r.satisfechos ?? 0}</TableCell>
              <TableCell align="right">{r.reclamos ?? 0}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

const BreakdownsPanel = ({ stats, isTV = false }) => {
  const classes = useStyles();
  const bd = stats?.breakdowns;
  if (!bd) return null;

  const hasSucursal = (bd.bySucursal?.length ?? 0) > 0;
  const hasTipo = (bd.byTipoEncuesta?.length ?? 0) > 0;
  const hasSubtipo = (bd.bySubtipo?.length ?? 0) > 0;
  if (!hasSucursal && !hasTipo && !hasSubtipo) return null;

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.breakdowns.title")}
        <InfoTip tipKey="breakdowns" isTV={isTV} />
      </Typography>
      {hasSucursal && (
        <>
          <div className={classes.subTitle}>
            {i18n.t("aiAssistantStats.breakdowns.bySucursal")}
          </div>
          <BTable rows={bd.bySucursal} keyLabel={i18n.t("aiAssistantStats.filters.sucursal")} />
        </>
      )}
      {hasTipo && (
        <>
          <div className={classes.subTitle}>
            {i18n.t("aiAssistantStats.breakdowns.byTipoEncuesta")}
          </div>
          <BTable rows={bd.byTipoEncuesta} keyLabel={i18n.t("aiAssistantStats.filters.tipoEncuesta")} />
        </>
      )}
      {hasSubtipo && (
        <>
          <div className={classes.subTitle}>
            {i18n.t("aiAssistantStats.breakdowns.bySubtipo")}
          </div>
          <BTable rows={bd.bySubtipo} keyLabel={i18n.t("aiAssistantStats.breakdowns.bySubtipo")} />
        </>
      )}
    </Paper>
  );
};

export default BreakdownsPanel;
